<template>
    <admin-layout :show-sidebar="false" mainPage="project">

        <app-content-pane class="ml-3">
            <template #title>
                <heading :project="project" :path="project.learning_path" page="teams" :tenants="tenants" />
                <hr class="mb-0">
            </template>

            <section>
                <div class="px-4 py-3 d-flex align-items-center">
                    <h4 class="mr-auto my-2">Manage your teams &amp; students</h4>
                    <div class="actions">
<!--                        <a href="#" class="btn btn-light ml-3 border">-->
<!--                            <img src="/images/icons/edit.svg" class="mr-1" style="max-widtd: 16px; max-height: 16px; margin-top: -3px" alt="">-->
<!--                            Bulk Edit-->
<!--                        </a>-->
                        <button type="button"
                                href="#"
                                class="btn btn-secondary ml-3"
                                @click="addTeam()">+ Add Team</button>
                    </div>
                </div>


                <add-team-modal :show="add_team_modal.enabled"
                                :project="project"
                                @teams-added="teamsAdded"
                                @close="closeAddTeam()"/>


                <div v-if="teams.length" class="scrollable-rows">

                    <div class="controls">
                        <a href="#" @click.prevent="scrollLeft()" class="left">
                            <icon-chevron-left size="20" color="dark"/>
                        </a>
                        <a href="#" @click.prevent="scrollRight()" class="right">
                            <icon-chevron-right size="20" color="dark"/>
                        </a>
                    </div>

                    <div class="s-row sticky bg-white">
                        <div class="s-head"></div>
                        <div class="s-cols" :style="{width: `${scroller.width}px`}">
                            <div class="s-col" v-for="team in teams" :key="team.id">
                                <div class="project-name">
                                    <h3 class="h5">
                                        <name-icon :value="team"
                                                   :show-name="true"
                                                   :editable="true"
                                                   @change="updateTeamName(team, $event)" />
                                    </h3>
                                    <a :href="route('project.canvas.show', {project, team, ...global_url_params})"
                                       target="_blank"
                                       class="btn btn-primary">Preview</a>
                                </div>
                            </div>
                            <div class="s-col col-mini"></div>
                        </div>
                    </div>
                    <div class="s-row">
                        <div class="s-head bg-white">Students</div>
                        <div class="s-cols" :style="{width: `${scroller.width}px`}">
                            <div class="s-col" v-for="team in teams" :key="team.id">
                                <div v-for="student in team.members" :key="student.id" class="member">
                                    <name-icon :value="student"
                                               :show-name="true"
                                               :editable="true"
                                               @change="updateStudentName(student, $event)" />
                                    <button @click.prevent.stop="removeStudent(team, student)"
                                            title="Remove Student"
                                            class="btn btn-danger">&times;</button>
                                </div>
                                <div class="add-member mt-3">
                                    <div class="add-students" v-if="add_students[team.id]">
                                        <div class="form-group">
                                            <textarea class="form-control"
                                                      rows="8"
                                                      :disabled="add_students[team.id].is_busy"
                                                      :placeholder="'Copy and paste one student per line. For example:\n\nKathy P\nJohn T'"
                                                      v-model="add_students[team.id].names"/>
                                        </div>

                                        <div class="d-flex">

                                            <button class="btn btn-warning mr-auto"
                                                          :disabled="add_students[team.id].is_busy"
                                                          @click.prevent.stop="cancelAddStudents(team)">Cancel</button>

                                            <state-button class="btn btn-primary"
                                                          :disabled="add_students[team.id].is_busy"
                                                          :state="add_students[team.id].is_busy ? 'busy' : ''"
                                                          @click.prevent.stop="createStudents(team)">Save</state-button>

                                        </div>
                                    </div>
                                    <button v-else class="btn btn-outline-dark"
                                            @click="addStudents(team)">Add Students</button>
                                </div>
                            </div>
                            <div class="s-col col-mini"></div>
                        </div>
                    </div>
<!--                    <div class="s-row">-->
<!--                        <div class="s-head bg-white">Invitation Code</div>-->
<!--                        <div class="s-cols" :style="{width: `${scroller.width}px`}">-->
<!--                            <div class="s-col" v-for="team in teams" :key="team.id">-->
<!--                                <div class="h4 mb-0">{{ canvasCode( team ) }}</div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="s-row">-->
<!--                        <div class="s-head bg-white">Invitation Link</div>-->
<!--                        <div class="s-cols" :style="{width: `${scroller.width}px`}">-->
<!--                            <div class="s-col" v-for="team in teams" :key="team.id">-->
<!--                                <inertia-link class="ellipsis"-->
<!--                                              :href="route('student.canvas.show', {uuid: canvasCode( team ), ...global_url_params})">-->
<!--                                    {{ route('student.canvas.show', {uuid: canvasCode( team ), ...global_url_params}) }}-->
<!--                                </inertia-link>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="s-row">
                        <div class="s-head bg-white text-feel">Student Canvas</div>
                        <div class="s-cols" :style="{width: `${scroller.width}px`}">
                            <div class="s-col" v-for="team in teams" :key="team.id">
                                <!-- <inertia-link class="ellipsis"
                                              :href="route('student.canvas.show', {uuid: canvasCode( team ), ...global_url_params})">
                                              {{ route('student.canvas.show', {uuid: canvasCode( team ), ...global_url_params}) }}
                                </inertia-link> -->
                                <div class="student-link-holder">
                                    <input type="text" @click="selectText($event)" :value="route('student.canvas.show', {uuid: canvasCode( team ), ...global_url_params})" readonly/>
                                    <div class="clipboard" @mouseenter="showTooltip($event)" @mouseleave="hideTooltip($event)" @click="copyToClipboard($event, route('student.canvas.show', {uuid: canvasCode( team ), ...global_url_params}))">
                                        &#128279;
                                        <div class="tooltip">Copy to clipboard</div>
                                    </div>
                                </div>
                            </div>
                            <div class="s-col col-mini"></div>
                        </div>
                    </div>

<!--                    <div class="s-row">-->
<!--                        <div class="s-head bg-white">Public Canvas Link</div>-->
<!--                        <div class="s-cols" :style="{width: `${scroller.width}px`}">-->
<!--                            <div class="s-col" v-for="team in teams" :key="team.id">-->
<!--                                &lt;!&ndash; TODO: Separate public uuid hash &ndash;&gt;-->
<!--                                <inertia-link class="ellipsis"-->
<!--                                              :href="route('canvas.public', {uuid: canvasPublicCode( team ), ...global_url_params})">-->
<!--                                    {{ route('canvas.public', {uuid: canvasPublicCode( team ), ...global_url_params}) }}-->
<!--                                </inertia-link>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

                    <div class="s-row">
                        <div class="s-head bg-white">DELETE TEAM</div>
                        <div class="s-cols" :style="{width: `${scroller.width}px`}">
                            <div class="s-col" v-for="team in teams" :key="team.id">
                                <div>
                                    <button class="btn btn-danger"
                                            @click.prevent.stop="removeTeam(team)">Delete Team &amp; Canvas</button>
                                </div>
                            </div>
                            <div class="s-col col-mini"></div>
                        </div>
                    </div>
                </div>
                <div v-else class="">
                    <div class="alert alert-warning mb-0">
                        <p>
                            This project have no teams yet.
                        </p>
                        <a class="btn btn-primary"
                           @click.stop.prevent="addTeam()"
                           href="#">Create team now</a>
                    </div>
                </div>

            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import DashboardToolbox from "@/Components/Toolbox/DashboardToolbox";
import AppContentPane from "@/Components/AppContentPane";
import Heading from "@/Components/Project/Heading";
import NameIcon from "@/Components/Team/NameIcon";
import jQuery from "jquery";
import AddTeamModal from "@/Components/Team/AddTeamModal";
import API from "@/API";
import StateButton from "@/Components/Common/StateButton";
import IconChevronLeft from "@/Icons/IconChevronLeft";
import IconChevronRight from "@/Icons/IconChevronRight";

export default {
    name: "Teams",
    components: {
        IconChevronRight,
        IconChevronLeft,
        StateButton, AddTeamModal, AppContentPane, DashboardToolbox, AdminLayout, Heading, NameIcon},
    props: ['project', 'tenants'],

    data(){
        return {

            add_team_modal: {
                enabled: false,
            },

            add_students: {},

            scroller: {
                $win        : jQuery(window),
                $app_left   : null,
                $cols       : null,
                $heads      : null,
                width       :0,
            }
        }
    },


    computed: {
        teams:{
            get(){
                return this.project.teams;
            },
            set(teams){
                this.project.teams = teams;
            },
        },
        canvases(){
            return this.project.canvases;
        },
    },


    methods: {
        getCanvas(team){
            return this.canvases.find(c => c.team_id === team.id);
        },

        canvasCode(team){
            const canvas = this.getCanvas( team );
            try { return canvas.uuid.substr(0, 16).toUpperCase(); } catch (e) {}
            return null;
        },

        canvasPublicCode(team){
            const canvas = this.getCanvas( team );
            try { return canvas.uuid.toUpperCase(); } catch (e) {}
            return null;
        },

        resize(){
            if( !this.scroller.$app_left ) return;
            this.scroller.width = this.scroller.$win.width()
                - this.scroller.$app_left.width() // Left sidebar width.
                - 200 // Head Width
                - 16  // Left margin of content area
                /*- 24  // Right margin of content area */;
        },

        initScroller(){
            const scroller = this.scroller;
            scroller.$app_left = jQuery('.app-left');
            scroller.$cols = jQuery('.s-row');
            scroller.$heads = jQuery('.s-head');
            scroller.$controls = jQuery('.controls .left, .controls .right');

            this.scroller.$win.on('scroll', this.winScroll);

            $('.app-nav').on('click', () => setTimeout(this.resize, 500));
            scroller.$win.resize( this.resize );
            this.resize();

            scroller.$cols.filter('.sticky').on('wheel', function(e){
                e.preventDefault();
                e.stopPropagation();
                const $current = $(this);
                $current.scrollLeft($current.scrollLeft() + e.originalEvent.deltaY + e.originalEvent.deltaX);
            });

            scroller.$cols.not('.sticky').on('wheel', function(e){
                e.stopPropagation();
                const $current = $(this);
                $current.scrollLeft($current.scrollLeft() + e.originalEvent.deltaX);
            });

            scroller.$cols.scroll(function(ev){
                const $current = jQuery(this);
                scroller.$cols.not($current).scrollLeft( $current.scrollLeft() );
                scroller.$heads.css({left: $current.scrollLeft() + 'px'});
            });
        },

        winScroll(ev){
            const scroll = this.scroller.$win.scrollTop();
            if( scroll > 191 ){
                this.scroller.$controls.css({top: scroll - 191});
            }else{
                this.scroller.$controls.css({top: 0});
            }
        },

        removeScroller(){
            this.scroller.$cols.filter('.sticky').off('wheel');
            this.scroller.$cols.off('scroll');
            $('.app-nav').off('click');
            this.scroller.$win.off('resize', this.resize);
            this.scroller.$win.off('scroll', this.winScroll);
        },

        scrollLeft(){
            const $head = jQuery('.s-row.sticky');
            $head.animate({scrollLeft: $head.scrollLeft() - 300}, 300);
        },

        scrollRight(){
            const $head = jQuery('.s-row.sticky');
            $head.animate({scrollLeft: $head.scrollLeft() + 300}, 300);
        },

        addStudents(team){
            this.add_students[team.id] = {
                names: '',
                is_busy: false,
            };
        },

        cancelAddStudents(team){
            delete this.add_students[team.id];
        },

        async createStudents(team){
            if( !this.add_students[team.id] ) return;
            this.add_students[team.id].is_busy = true;

            try{
                const updatedTeam = await API.teams.createStudents(team.id, this.add_students[team.id].names);
                const idx = this.teams.findIndex(t => t.id === updatedTeam.id);
                if( idx >= 0 ) this.teams[ idx ] = updatedTeam;
                this.cancelAddStudents(team);
            }catch (e) {
                this.add_students[team.id].is_busy = false;
                // console.log(e);
            }
        },

        async removeStudent(team, student){
            if(!confirm("Are you sure to remove this student from team?" )) return;
            const removedStudent = await API.teams.removeStudent(team.id, student.id);
            await this.$inertia.reload({only: ['project']});
        },

        async removeTeam(team){
            if( ! confirm("!!WARNING!!\n\n" +
                "This action will remove all students in this team and all associated canvas data." +
                "This action can't be undone.\n\n" +
                "Are you sure to remove this team?"
            ) ) return;

            const destroyed = await API.teams.destroy(team.id);
            await this.$inertia.reload({only: ['project']});

            console.log({destroyed});

        },

        teamsAdded(teams){
            console.log({teams});
            this.$inertia.reload({only: ['project']});
            this.closeAddTeam();
        },

        addTeam(){
            this.add_team_modal.enabled = true;
        },

        closeAddTeam(){
            this.add_team_modal.enabled = false;
        },


        async updateTeamName(team, name){
            const result = await API.teams.update(team.id, {name: name});
            team.name = result.name;
        },

        async updateStudentName(student, first_name){
            const result = await API.users.update(student.id, {first_name});
            student.first_name = result.first_name;
        },

        selectText(e) {
            e.target.select()
            e.target.setSelectionRange(0, 99999)
        },

        showTooltip(e) {
            e.target.querySelector(".tooltip").style.opacity = 1
        },

        hideTooltip(e) {
            const tooltip = e.target.querySelector(".tooltip")
            tooltip.style.opacity = 0
            setTimeout(() => {
                tooltip.innerText = "Copy to clipboard"
            }, 500)
        },

        copyToClipboard(e, text) {
            navigator.clipboard.writeText(text)
            e.target.querySelector(".tooltip").innerText = "Copied!"
        }

    },

    mounted() {
        this.initScroller();

        this.setTitle( `${this.project.name} - Teams` );

    },

    beforeUnmount() {
        this.removeScroller();
    }

}
</script>

<style lang="scss" scoped>

.teams{
    .col{
        min-width: 360px;
        max-width: 420px;
    }
}

.user-list{
    list-style: none;
    margin: 0;
    padding: 0;

    li {
        margin: 0.3rem 0;
        padding: 0;
        display: flex;
        align-items: center;

        img {
            width: 32px;
            height: auto;
            box-shadow: $box-shadow-sm;
            border-radius: 3px;
            margin-right: 0.6rem;
        }
    }
}

.invitation{
    background: white;
    border-top: $light-borders solid 1px;
    border-bottom: $light-borders solid 1px;
    padding: 0.5rem 1.25rem;
    margin: 1rem -1.25rem 0;
    font-weight: $font-weight-semibold;
    font-size: 1rem;
}

$scrollable-head-width: 200px;
$scrollable-column-width: 380px;

.scrollable-rows{
    .s-row{
        display: flex;
        align-items: stretch;
        padding-left: $scrollable-head-width;
        position: relative;
        overflow-x: hidden;
        border-bottom: rgba(black, 0.1) solid 1px;

        &:first-child{
            border-top: rgba(black, 0.1) solid 1px;
        }

        &.sticky{
            overflow: auto;
            position: sticky;
            top: 60px;
            z-index: 5;
            border-top: rgba(black, 0.1) solid 1px;

            .s-head{
                box-shadow: none;
            }
        }
        .student-link-holder {
            display: flex;
            align-items: center;
            gap: 5px;
            input {
                width: 100%;
                padding: 0 10px;
                border-radius: 5px;
                border: 1px solid #666666;
            }
            .clipboard {
                cursor: pointer;
                position: relative;
                .tooltip {
                    position: absolute;
                    background-color: white;
                    padding: 5px;
                    top: 50%;
                    left: -5px;
                    transform: translate(-100%, -50%);
                    box-shadow: 0 0 5px #646464;
                    transition: opacity 0.5s ease;
                    pointer-events: none;
                }
            }
        }
    }

    .s-head, .s-col{
        padding: 1rem;
        z-index: 1;
    }

    .s-head{
        flex: 0 0 $scrollable-head-width;
        width: $scrollable-head-width;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        box-shadow: rgba(black, 0.1) 2px 0 5px;
        font-weight: $font-weight-bold;
        z-index: 2;
    }

    .s-cols{
        padding-right: 1.5rem;
        display: flex;
        align-items: stretch;
    }

    .s-col{
        display: flex;
        flex-direction: column;
        flex: 0 0 $scrollable-column-width;
        width: $scrollable-column-width;
        min-height: 2rem;
        border-right: rgba(black, 0.1) solid 1px;

        &:last-child{
            // border-right: none;
        }

        &.col-mini{
            flex: 0 0 100px;
            width: 100px;
        }
    }

    .ellipsis{
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

}

.project-name{
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .btn{
        margin-left: auto;
    }
}

.member{
    display: flex;
    padding: 0.5rem 1rem;
    align-items: center;
    border-bottom: $light-borders solid 1px;
    margin-left: -1rem;
    margin-right: -1rem;

    .btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.6rem;
        height: 1.6rem;
        margin-left: auto;
        border-radius: 50%;
    }
}

.scrollable-rows{
    position: relative;
}

.controls{
    position: relative;
    z-index: 10;

    .left, .right{
        position: absolute;
        top: 0;
        width: 3rem;
        height: 5.48rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(white, 0.7);
        font-weight: $font-weight-bold;
        border-radius: 0 .3rem .3rem 0;
        backdrop-filter: blur(5px);
        border: $light-borders solid 1px;
    }

    .left{
        left: 0;
    }
    .right{
        right: 0;
    }
}

.link-btn {
    padding: 5px;
    color: white;
    border: none;
    margin-bottom: 5px;
    width: 100%;
    font-size: 20px;
    font-weight: 600;
    transition-duration: 0.3s;
}

.link-btn:hover {
    opacity: 0.8;
}

.link-btn.first {
    background: #2ba05e;
}
.link-btn.second {
    background: #2b77a0;
}
</style>
